import React from 'react';
import { FiMic } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { channelInfo as defaultChannelInfo } from '../data/podcastData';

const PodcastHeader = ({ channel }) => {
  // Fallback to default static data if dynamic feed doesn't provide it
  const title = channel?.title || defaultChannelInfo.title;
  const description = channel?.description || defaultChannelInfo.description;
  const image = channel?.image || defaultChannelInfo.image;

  return (
    <div className="mb-8 text-center md:text-left flex flex-col md:flex-row items-center gap-6 pb-8 border-b border-brand-green/10">
      <div className="relative flex-shrink-0">
        <div className="absolute -inset-2 bg-brand-tan/20 rounded-full blur-xl animate-pulse"></div>
        <img 
          src={image} 
          alt={title} 
          className="relative w-24 h-24 md:w-28 md:h-28 rounded-xl shadow-lg border-2 border-brand-tan/20 object-cover bg-brand-green/10" 
        />
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
          <span className="bg-brand-dark text-white text-[10px] font-bold px-2 py-0.5 rounded tracking-tighter uppercase flex items-center gap-1">
            <SafeIcon icon={FiMic} className="w-3 h-3" /> Podcast
          </span>
          <span className="text-brand-tan font-bold text-[10px] tracking-widest uppercase">
            RSS Feed
          </span>
        </div>
        
        <h1 className="text-2xl md:text-3xl font-bold text-brand-dark mb-2 leading-tight font-serif truncate">
          {title}
        </h1>
        
        <p className="text-brand-green/70 text-sm max-w-2xl italic font-serif line-clamp-3">
          {description.replace(/<[^>]*>/g, '') /* Strip HTML tags from description */}
        </p>
      </div>
    </div>
  );
};

export default PodcastHeader;